import React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import PcrWidget from './PcrWidget';


interface PcrPageProps extends IAppPropsWithRoute {

};

const PcrPage: React.FC<PcrPageProps> = () =>{
    const dispatch = useDispatch();
    
    React.useEffect(() => {
        dispatch(showNavbar(true));
        if (navigator.onLine) {
            console.log("online");
          } else {
            console.log("offline");
          }
    }, [])
    
    return (
        <>
            <PcrWidget />
        </>
    );
}

export default React.memo(withRouter(PcrPage));